import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Es un libro físico?',
    a: 'No, es un sistema 100% digital (PDFs y guías) que recibís en tu email inmediatamente después de la compra. Sin costos de envío ni esperas.'
  }, {
    q: '¿Sirve si soy introvertido?',
    a: 'Especialmente si sos introvertido. Este sistema no te pide que seas el alma de la fiesta, sino que aprendas a observar y actuar con estrategia quirúrgica.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía incondicional. Si sentís que no aprendiste nada nuevo, te devolvemos el 100% de tu dinero. Sin preguntas.'
  }, {
    q: '¿Los métodos son éticos?',
    a: 'Son herramientas. Como un martillo, podés usarlo para construir o destruir. Enseñamos ética, pero el poder final está en tus manos.'
  }, {
    q: '¿Cómo accedo a los bonus?',
    a: 'Vienen incluidos en el pack de descarga que recibís automáticamente al confirmar tu pago.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-black border-t border-zinc-900" data-id="element-115">
      <h2 className="text-3xl font-bold text-white text-center mb-12" data-id="element-116">
        Preguntas Frecuentes
      </h2>
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-117">
        {faqs.map((faq, i) => <div key={i} className="border border-zinc-800 rounded-lg bg-zinc-900 overflow-hidden" data-id="element-118">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left hover:bg-zinc-800 transition-colors" data-id="element-119">
              <span className="font-bold text-zinc-200" data-id="element-120">{faq.q}</span>
              {openIndex === i ? <Minus className="w-5 h-5 text-yellow-500" data-id="element-121" /> : <Plus className="w-5 h-5 text-zinc-500" data-id="element-122" />}
            </button>
            <AnimatePresence data-id="element-123">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="overflow-hidden" data-id="element-124">
                  <div className="p-5 pt-0 text-zinc-400 text-sm leading-relaxed border-t border-zinc-800/50" data-id="element-125">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}